import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MobileMenuComponent } from './mobile-menu.component';

@NgModule({
  declarations: [MobileMenuComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule
  ],
  exports: [MobileMenuComponent]
})
export class MobileMenuModule { }
